import type { ComponentPropsWithRef } from 'react';

/**
 * 리치 에디터 placeholder.
 *
 * TODO: TipTap 또는 Lexical 통합은 후속 단계에서 결정·적용.
 *       form value 형식(string 마크다운)을 유지하면 RHF 통합 변경 없이 교체 가능.
 */
export default function EditorPlaceholder(props: ComponentPropsWithRef<'textarea'>) {
  return (
    <textarea
      rows={20}
      placeholder="마크다운 본문..."
      className="mt-1 block w-full rounded border border-slate-300 bg-white px-3 py-2 font-mono text-sm focus:border-slate-500 focus:outline-none"
      {...props}
    />
  );
}
